<template>
  <div>
    <Nav></Nav>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Menus:</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button size="sm" variant="success" v-b-modal.modal-createPlatformMenu>Crear Menu</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table 
            small 
            responsive 
            striped 
            hover 
            :items="menus" 
            :fields="tableFields"
            :filter="search"
            :busy="isLoading">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(is_active)="data">
              <b-badge variant="success" v-if="data.item.is_active">Activo</b-badge>
              <b-badge variant="danger" v-else>Inactivo</b-badge>
            </template>
            <template #cell(buttons)="data">
              <b-button-group vertical>
                <b-button size="sm" variant="warning" @click="editMenu(data.item)">Editar</b-button>
                <b-button size="sm" variant="success" @click="sendMenu(data.item)">Enviar</b-button>
                <b-button size="sm" variant="info" @click="viewSchedules(data.item.id)">Horarios</b-button>
                <b-button size="sm" variant="danger" @click="confirmDelete(data.item.id)">Eliminar</b-button>
              </b-button-group>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>

    <!-- Create/Edit Menu Modal -->
    <b-modal id="modal-createPlatformMenu" :title="isEditing ? 'Editar Menu' : 'Crear Menu'" @ok.prevent="submitMenu">
      <form ref="menuForm" @submit.stop.prevent="submitMenu">
        <b-form-group
          label="Nombre:"
          label-for="name-input"
          :state="nameValidation"
          :invalid-feedback="'El nombre es requerido'">
          <b-form-input
            id="name-input"
            v-model="currentMenu.name"
            :state="nameValidation"
            required
          ></b-form-input>
        </b-form-group>
        
        <b-form-group label="Descripción:">
          <b-form-textarea
            v-model="currentMenu.description"
            placeholder="Describe el propósito de este menú"
            rows="3"
          ></b-form-textarea>
        </b-form-group>
        
        <b-form-group>
          <b-form-checkbox v-model="currentMenu.is_active">
            Menu Activo
          </b-form-checkbox>
        </b-form-group>
      </form>
    </b-modal>

    <!-- Schedules Modal -->
    <b-modal id="modal-menuSchedules" title="Horarios del Menu" size="lg" @hidden="resetScheduleForm">
      <b-row>
        <b-col>
          <h5 class="mb-3">Horarios para: {{ currentMenu.name }}</h5>
        </b-col>
      </b-row>
      
      <b-table 
        small 
        responsive 
        striped 
        hover 
        :items="schedules" 
        :fields="scheduleFields"
        :busy="isLoadingSchedules">
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Cargando horarios...</strong>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="deleteSchedule(data.item.id)">
            <i class="fas fa-trash"></i>
          </b-button>
        </template>
      </b-table>

      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col md="3">
              <b-form-group label="Día:">
                <b-form-select v-model="newSchedule.day_of_week" :options="daysOfWeek"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Hora inicio:">
                <b-form-input v-model="newSchedule.start_time" type="time"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Hora fin:">
                <b-form-input v-model="newSchedule.end_time" type="time"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3" class="d-flex align-items-end">
              <b-button variant="success" @click="addSchedule" class="mb-3">Agregar Horario</b-button>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-end">
            <b-button variant="secondary" @click="$bvModal.hide('modal-menuSchedules')">Cerrar</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Nav from "../Nav.vue";

export default {
  name: "PlatformMenus",
  components: { Nav },
  data() {
    return {
      menus: [],
      schedules: [],
      isLoading: false,
      isLoadingSchedules: false,
      isEditing: false,
      currentMenu: {
        id: "",
        name: "",
        description: "",
        is_active: true
      },
      newSchedule: {
        day_of_week: "monday",
        start_time: "08:00",
        end_time: "22:00"
      },
      search: "",
      tableFields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "description", label: "Descripción", sortable: true },
        { key: "is_active", label: "Estado", sortable: true },
        { key: "buttons", label: "Acciones" }
      ],
      scheduleFields: [
        { key: "day_of_week", label: "Día", sortable: true, formatter: this.formatDay },
        { key: "start_time", label: "Hora Inicio", sortable: true },
        { key: "end_time", label: "Hora Fin", sortable: true },
        { key: "actions", label: "Acciones" }
      ],
      daysOfWeek: [
        { value: "monday", text: "Lunes" },
        { value: "tuesday", text: "Martes" },
        { value: "wednesday", text: "Miércoles" },
        { value: "thursday", text: "Jueves" },
        { value: "friday", text: "Viernes" },
        { value: "saturday", text: "Sábado" },
        { value: "sunday", text: "Domingo" }
      ]
    };
  },
  computed: {
    nameValidation() {
      return this.currentMenu.name ? true : false;
    }
  },
  mounted() {
    this.getAllMenus();
  },
  methods: {
    formatDay(value) {
      const dayMap = {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo"
      };
      return dayMap[value] || value;
    },
    getAllMenus() {
      this.isLoading = true;
      axios
        .get("/platform/menus")
        .then(response => {
          this.menus = response.data;
        })
        .catch(err => {
          this.makeToast("Error", err.response?.data?.message || "Error al obtener menús", "danger");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    sendMenu(menu) {
      
      this.$bvModal.msgBoxConfirm("¿Estás seguro que deseas enviar este menú a las plataformas asignadas?")
      .then(result => {
        if (result) {
          this.isLoading = true;
          axios
            .post(`/platform/menu/${menu.id}/send`)
            .then(() => {
              this.makeToast("Éxito", "Menú enviado", "success");
              this.getAllMenus();
            })
            .catch(err => {
              this.makeToast(
                "Error", 
                err.response?.data?.message || "Error al enviar el menú", 
                "danger"
              );
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
    editMenu(menu) {
      this.isEditing = true;
      this.currentMenu = { ...menu };
      this.$bvModal.show("modal-createPlatformMenu");
    },
    resetMenu() {
      this.currentMenu = {
        id: "",
        name: "",
        description: "",
        is_active: true
      };
      this.isEditing = false;
    },
    submitMenu() {
      if (!this.currentMenu.name) {
        // Validation failed
        return;
      }

      const method = this.isEditing ? "PUT" : "POST";
      const url = this.isEditing 
        ? `/platform/menu/${this.currentMenu.id}` 
        : '/platform/menu';

      axios({
        method,
        url,
        data: this.currentMenu
      })
        .then(() => {
          this.makeToast(
            "Éxito", 
            `Menu ${this.isEditing ? 'actualizado' : 'creado'} exitosamente`, 
            "success"
          );
          this.getAllMenus();
          this.$bvModal.hide("modal-createPlatformMenu");
          this.resetMenu();
        })
        .catch(err => {
          this.makeToast(
            "Error", 
            err.response?.data?.message || `Error al ${this.isEditing ? 'actualizar' : 'crear'} el menu`, 
            "danger"
          );
        });
    },
    confirmDelete(id) {
      this.$bvModal.msgBoxConfirm("¿Estás seguro que deseas eliminar este menú? Esta acción no se puede deshacer.", {
        title: "Confirmar eliminación",
        okVariant: "danger",
        okTitle: "Eliminar",
        cancelTitle: "Cancelar",
        centered: true
      })
      .then(result => {
        if (result) {
          this.deleteMenu(id);
        }
      });
    },
    deleteMenu(id) {
      axios
        .delete(`/platform/menu/${id}`)
        .then(() => {
          this.makeToast("Éxito", "Menu eliminado exitosamente", "success");
          this.getAllMenus();
        })
        .catch(err => {
          this.makeToast(
            "Error", 
            err.response?.data?.message || "Error al eliminar el menu", 
            "danger"
          );
        });
    },
    viewSchedules(menuId) {
      this.currentMenu.id = menuId;
      const menu = this.menus.find(m => m.id === menuId);
      if (menu) {
        this.currentMenu.name = menu.name;
      }
      this.getSchedules(menuId);
      this.$bvModal.show("modal-menuSchedules");
    },
    getSchedules(menuId) {
      this.isLoadingSchedules = true;
      axios
        .get(`/platform/menu/${menuId}/schedules`)
        .then(response => {
          this.schedules = response.data;
        })
        .catch(err => {
          this.makeToast(
            "Error", 
            err.response?.data?.message || "Error al obtener horarios", 
            "danger"
          );
        })
        .finally(() => {
          this.isLoadingSchedules = false;
        });
    },
    addSchedule() {
      if (!this.newSchedule.day_of_week || !this.newSchedule.start_time || !this.newSchedule.end_time) {
        this.makeToast("Error", "Todos los campos son requeridos", "danger");
        return;
      }

      axios
        .post(`/platform/menu/${this.currentMenu.id}/schedule`, this.newSchedule)
        .then(() => {
          this.makeToast("Éxito", "Horario agregado exitosamente", "success");
          this.getSchedules(this.currentMenu.id);
          this.resetScheduleForm();
        })
        .catch(err => {
          this.makeToast(
            "Error", 
            err.response?.data?.message || "Error al agregar horario", 
            "danger"
          );
        });
    },
    deleteSchedule(scheduleId) {
      axios
        .delete(`/platform/menu/schedule/${scheduleId}`)
        .then(() => {
          this.makeToast("Éxito", "Horario eliminado exitosamente", "success");
          this.getSchedules(this.currentMenu.id);
        })
        .catch(err => {
          this.makeToast(
            "Error", 
            err.response?.data?.message || "Error al eliminar horario", 
            "danger"
          );
        });
    },
    resetScheduleForm() {
      this.newSchedule = {
        day_of_week: "monday",
        start_time: "08:00",
        end_time: "22:00"
      };
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    }
  }
};
</script>
